import {
  Component,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  OnDestroy,
  ViewChild,
} from "@angular/core";

// Services
import { env } from "../../../../environments/environment";
import { CoreLogService } from "../../services/log.service";
import {
  CheckoutService,
  LastOrderInfo,
} from "../../services/checkout.service";
import { CoreLanguageService } from "../../services/language.service";
import {
  CheckoutPaymentModel,
  CheckoutPaymentMethodsModel,
  InHouseDataModel,
  ResponseCode_Done,
} from "../../shared/models/checkout.model";
import { CoreCOMService } from "../../services/com.service";
import { Subscription } from "rxjs";
import { Subject } from "rxjs/Subject";
import { takeUntil } from "rxjs/operators";
import {
  AddPurchaseOrderDataModel,
  OrdertypeViewModel,
  AddPurchaseOrderItemDataModel,
  orderTypes,
  VatStat,
} from "../../shared/models/webshop.model";
import { WebVoucherService } from "../../services/web_voucher.service";
import { GetWebVoucherDataModel } from "../../shared/models/web_voucher.model";
import * as _ from "lodash";
import Utils from "../../shared/utils";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { MatCheckboxChange, MatDialog } from "@angular/material";
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode, Webvoucher } from "../../services/IWebShopService";
import { ActivatedRoute, Router } from "@angular/router";
import { TermService } from "../term/term.service";
import { SettingsRegistrationViewModel } from "../../shared/models/settings.model";
import { DomSanitizer } from "@angular/platform-browser";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { FormControl, } from "@angular/forms";
import { ClientType } from "../../services/com/comEnvironmentClient";
import * as moment from "moment";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { CheckoutLocationViewModel } from "../../shared/models";
import { SnackBarService, } from "../../services/snackBar.service";
import { SnackBarMessageType } from "../../shared/contentTypes";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import {
  SecureCheckDialogComponent,
  WarningdialogComponent,
  LocationImpressumDialogComponent,
  ErrorDialogComponent,
} from "../../modalDialogs";
import { AccountPaymentService } from "../../services/accountPayment.service";
import { AccountPaymentRequestDialogService } from "../../services/accountPaymentRequestDialog.service";
import {
  ACCOUNT_PAYMENT_DIALOG_CHANGE_PAYMENT_METHOD_LANGKEY,
  AccountPaymentCreditValues,
  AccountPaymentLimitResult,
  AccountPaymentRowState,
  AccountingCustomerDataModel,
} from "../../shared/models/accountPayment.model";
import { LocationService } from "../location/location.service";
import { ProductService } from "../../services/product.service";
import { TrackingManager } from "../../services/tracking/tracking-manager";
import { ValidatorsConfig, webVoucherValidator } from "../../shared/validator/validator.function";
import { INavigationOptions, TimeSelectionStatus, TimeValidationResult } from "../../services/IOrderTimeValidation.service";
import { OrderTimeValidationService } from "../../services/orderTimeValidation.service";
import { NavigationRoute } from "../../shared/enums/navigation-route.enum";
import { NewsletterCheckboxComponent } from "../../directives";

/** Adyen Web Drop-In for Browser */
declare var AdyenCheckout: any;
/** Cordova plugin für den Support vom nativen DropIn für Android und iOS */
declare var Adyen: any;

/** CloudBox fehlermeldungen */
enum PaymentErrorCode {
  UndefinedError = 0,
  NoAccountID = 1,
  NoRequestData = 2,
  ResponseIsEmpty = 3,
  ResponseDataIsEmpty = 4,
  ResponseDataSetIsEmpty = 5,
  InvalidRequest = 6,
  ValidationError = 7,
  DataRecordCreationNotpossible = 8,
  UnKnownConnectorError = 9,
  NoItems = 10,
  GrosspriceWrong = 11,
  Multiple_Order = 12
}

/**
 * When using Wallee the Lightbox script will be requested and loaded dynamically.
 * Therefore we have to foreward declare it, to allow using it.
 */
declare var LightboxCheckoutHandler: any;

export enum CheckboxPaymentMethod {
  None = 0,
  Webvoucher,
  Cash,
  Cashless,
  Accounting,
  PayPal,
  Adyen,
  Wallee,
  PayAtWaiter,
}

type PaymentMethod = {
  details: {
    key: string;
    type: string;
  }[];
  name: string;
  type: string;
  brands: string[];
  icons: string[];
};

type WalleePaymentMethod = {
  connectorId: number;
  paymentMethodId: number;
  name: string;
  imageUrl: string;
};

/**
 * Checkout
 */
@Component({
  selector: "ya-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.scss"],
  providers: [OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutComponent implements OnInit, OnChanges, OnDestroy {

  public readonly APPLE_PAY_TYPE = "applepay";
  public readonly GOOGLE_PAY_TYPE = "paywithgoogle";
  public readonly CREDIT_CARD_TYPE = "scheme";

  // Übergabeparameter
  private _defaultHomeRoute: string = "/"; // Route für Home.
  @Input() private _backRoute: string;
  @Output() public navigateToBasket = new EventEmitter<void>();
  @ViewChild("newsletterCheckbox") newsletterCheckbox: NewsletterCheckboxComponent;

  public backRoute: string = this._defaultHomeRoute; // Route für Zurück.
  public currentLocation: number;
  public service: WebShopMode;
  public WebShopMode = WebShopMode;
  private dropin_last_cardbrand: string = null;
  public serviceId: number;
  public layoutClass: string = "layout-colorful"; // Welches Layout soll angezeigt werden?
  public checkoutLocation: CheckoutLocationViewModel;
  private _adyenDropInOptions: any;
  /** Hält die Referenz auf das aktuelle AdyenCheckout fürs DropIn */
  private _adyenCheckout: any;
  private _filteredAdyenDropInOptions: any;
  private _adyenWebDropIn: any;
  // visual
  public isInitialised: boolean = false;
  public adyenPaymentIcons: string[] = [];
  public walleePaymentMethods: WalleePaymentMethod[] = [];
  public showWebDropIn: boolean = false;
  public hasWebvoucher: boolean = false;
  public webvoucherBalance: number = 0;
  public webvoucherBalanceBonus: number = 0;
  public get webvoucherBalanceTotal() {
    return this.webvoucherBalance + this.webvoucherBalanceBonus || 0;
  }
  public webvoucherDiscount: number = 0;
  public webvoucherCardNr: string = "";
  public webvoucherInputPlaceholder: string = "";
  public likeIds: number[];
  public webvoucherPlaceholderText: string = "";
  public webvoucherInfoText: string = "";
  public useWebvoucherBalance: boolean = false;
  private adyenPaymentMethods: Array<PaymentMethod>;

  public get paymentMethodsForSplittedView(): Array<PaymentMethod> {
    return this.adyenPaymentMethods;
  }

  private splitPaymentMethods = false;

  public get useSplitPaymentMethods(): boolean {
    return this.splitPaymentMethods && !this.show_wallee; // Delegate to service call to YourAppServer goes here - Restriction : Wallee wont get a splitted view
  }
  /** basis preis ohne Rabatte oder Trinkgeld */
  public get sum_base(): number {
    return this.order.baseprice;
  }
  public get sum_discount(): number {
    return this.order.discountTotal;
  }
  public get sum_deposit(): number {
    return this.order.deposit;
  }
  public get sum_delivery_fee(): number {
    return this.order.deliveryCost;
  }
  public get sum_tip(): number {
    return this.order.tip;
  }
  public get sum_webvoucher(): number {
    return this.order.partialPaymentAmount;
  }
  public get sum_total(): number {
    return this.order.grossprice;
  }
  public get vatStats(): VatStat[] {
    return this.order.vatStats;
  }
  public vatEnumeration: string[] = ["A", "B", "C", "D", "E", "F", "G"]; // 7 Vats

  public show_hs_webvoucher: boolean = false;
  public show_hs_pay_at_waiter: boolean = false;
  public show_hs_cash: boolean = false;
  public show_hs_cashless: boolean = false;
  public show_hs_accounting: boolean = false;
  /** Whether the customer is approved and within the credit limit. */
  public show_hs_accounting_customer: boolean = false;
  /** Whether account payment is enabled for the current order type. */
  private _accountPaymentEnabledForOrdertype: boolean = false;
  public show_hs_paypal: boolean = false;

  public accountPaymentLimitResult: AccountPaymentLimitResult = { isBlocked: false, isLimitReached: false, isOverLimit: false, exceedAmount: 0 };
  public accountPaymentCreditValues: AccountPaymentCreditValues | null = null;
  public accountPaymentCustomer: AccountingCustomerDataModel | null = null;
  public show_adyen: boolean = false;
  public show_wallee: boolean = false;

  public CheckboxPaymentMethod = CheckboxPaymentMethod;
  public AccountPaymentRowState = AccountPaymentRowState;
  public selectedPaymentMethod: CheckboxPaymentMethod =
    CheckboxPaymentMethod.None;

  public selectedSinglePaymentMethod = "";

  public get hasAcceptedAGB(): boolean {
    return this._webShopService.hasAcceptedAGB;
  }

  public set hasAcceptedAGB(accepted: boolean) {
    this._webShopService.hasAcceptedAGB = accepted;
    this.PushChanges();
  }

  public AGB_innerhtml: any = "";
  public settingsViewModel: SettingsRegistrationViewModel =
    new SettingsRegistrationViewModel();

  private externIntentSupscription: Subscription;
  private _localeChangeSubscription: Subscription;
  private _destroy$: Subject<void> = new Subject<void>();

  public order: AddPurchaseOrderDataModel = null;

  public ordertype: OrdertypeViewModel;

  private _order_id: string = "";
  /** orderID als Token, nur wenn OrderID nicht ein NoCOO Code ist */
  private _order_token: string = "";
  private _walleeTransactionToken: string = "";

  /** ordertype ist InHouse */
  public get in_house(): boolean {
    return this.order ? this.order.ordertype === orderTypes.inHouse : false;
  }

  //todo ordermode
  public get isRemoteGroupOrder_Pickup(): boolean {
    return this.order ? this.order.ordertype === orderTypes.pickupGroup : false;
  }

  //todo ordermode
  public get isRemoteGroupOrder_Delivery(): boolean {
    return this.order ? this.order.ordertype === orderTypes.deliveryGroup : false;
  }

  private _showBasketComment: boolean;
  public get isBasketComment(): boolean {
    return this._showBasketComment;
  }

  public commentPlaceholder: string = "";

  public voucherFC = new FormControl("", {
    updateOn: "blur",
    validators: ValidatorsConfig.forVoucherCode(),
    asyncValidators: webVoucherValidator(this.UseWebVoucher.bind(this)),
  });

  private _validationSubscrition: Subscription;

  private _isProcessingOrder = false;

  public get canUseWebvoucher(): boolean {
    return (
      this.show_hs_webvoucher || this._webShopService.canCollectBonuspoints
    );
  }

  constructor(
    private _checkoutService: CheckoutService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _webVoucherService: WebVoucherService,
    private _webShopService: WebShopService,
    private _inHouseOrderService: InHouseOrderService,
    private _internationalisationService: InternationalisationService,
    private _coreCOMService: CoreCOMService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLanguageService: CoreLanguageService,
    private _termService: TermService,
    private _overlaySpinnerService: OverlaySpinnerService,
    private _domSanitizer: DomSanitizer,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _snackBarService: SnackBarService,
    private _coreLogService: CoreLogService,
    private _locationService: LocationService,
    private _MatDialog: MatDialog,
    private _productService: ProductService,
    private _trackingManager: TrackingManager,
    private _orderTimeValidationService: OrderTimeValidationService,
    private _accountPaymentService: AccountPaymentService,
    private _accountPaymentRequestDialogService: AccountPaymentRequestDialogService
  ) {
    const me = this;

    _changeDetectorRef.detach();
    me._validationSubscrition = me.voucherFC.statusChanges.subscribe(() => {
      me.PushChanges();
    });
    me._showBasketComment = me._webShopService.useBasketComment();
    me.externIntentSupscription =
      me._coreCOMService.environment.events.externIntent.subscribe(
        (data: string) => me.onExternIntent(data)
      );
  }

  /** Alle Änderungen der gebundenen Variablen an der Oberfläche neu darstellen. (Rerender) */
  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error(
        "CheckoutComponent.PushChanges",
        "_changeDetectorRef.detectChanges (catch)",
        e
      );
    }
  }

  public get show_paymentmethods(): boolean {
    return (
      this.show_hs_cash ||
      this.show_hs_cashless ||
      this.show_hs_accounting ||
      this.shouldShowAccountPaymentRow ||
      this.show_hs_paypal ||
      this.show_adyen ||
      this.show_hs_pay_at_waiter
    );
  }

  /** True when account payment is configured for the current ordertype */
  public get accountPaymentEnabledForOrdertype(): boolean {
    return this._accountPaymentEnabledForOrdertype;
  }

  public initialize(
    addPurchaseOrder: AddPurchaseOrderDataModel,
    webvoucher: Webvoucher
  ) {
    const me = this;
    me.order = addPurchaseOrder;
    const locationID = me._webShopService.getServiceLocation();
    me.service = me._webShopService.getServiceMode();
    if (webvoucher) {
      me._webVoucherService
        .GetWebVoucherForLocation(webvoucher.cardnumber, locationID)
        .then((response) => {
          if (response.success) {
            if (me.order !== null) {
              // todo forübergehend werden im InHouse keine Gutschein Rabatte angewandt
              //! achtung checkout.component.ts UseWebVoucher beachten, hat selbe prüfung
              if (
                response.discount_bonus > 0 &&
                me._webShopService.getServiceMode() === WebShopMode.OrderToTable &&
                !Number.isNaN(me._inHouseOrderService.TableData.location) &&
                !me._inHouseOrderService.TableData.mandatory_Payment
              ) {
                // todo wenn rabatte berücksichtigt werden, kann es ausgebaut werden
                /** Momentan ist es nicht möglich digital mit einem Gutschein zu bezahlen */
                me.openVoucherCannotBeUsed();
                return;
              } // else in mandatory_Payment (PayNow) wird OrdarAndPay ausgeführt, damit ist dem Gast möglich Rabatt zu nutzen
              me.order.partialpaymentInfo = response.cardnumber;
              me.hasWebvoucher = true;
              me.webvoucherBalance = response.balance;
              me.webvoucherBalanceBonus = response.balance_bonus;
              me.webvoucherDiscount = response.discount_bonus;
              me.webvoucherCardNr = response.cardnumber;
              me._webShopService.setDiscounts({
                webvoucherDiscount: me.webvoucherDiscount,
              });

              me.setUseWebvoucher(false /*me.canUseWebvoucher*/);
            } else {
              me._coreLogService.error(
                "CheckoutComponent.tryWebvoucherCardNr",
                "No Order found"
              );
              return;
            }
          } else {
            // Todo Notify User of Incorrect CardNr
          }
        })
        .catch((error) => {
          me._overlaySpinnerService.HideLayoutSpinner();
          me._coreLogService.error(
            "CheckoutComponent.tryWebvoucherCardNr",
            "_webVoucherService.GetWebVoucher",
            error
          );
        });
    } else {
      me.setUseWebvoucher(false);
    }
  }

  public setOrderComment() {
    const me = this;
    me._webShopService.orderComment = me.order.comment;
    me._webShopService.saveToStorage();
  }

  private async saveLastOrderInfo() {
    const me = this;
    const lastOrderInfo = new LastOrderInfo();
    lastOrderInfo.id = me._order_id;
    lastOrderInfo.token = me._order_token;
    lastOrderInfo.ordertype = me.order.ordertype;
    lastOrderInfo.location = me.order.location;
    lastOrderInfo.qrCode = me.order.qrCode ? me.order.qrCode : "";
    lastOrderInfo.locTele = await me._webShopService.getLocationPhoneNumber(me.order.location);
    lastOrderInfo.handoverDate = me.order.wantedHandoverDate;
    lastOrderInfo.handoverTime = me.order.wantedHandoverTime;
    lastOrderInfo.handoverStreet =
      me.service === WebShopMode.Delivery || me.service === WebShopMode.DeliveryGroup
        ? me._webShopService.getDelivaryAddress().address ||
        me._webShopService.webshopOrderDataViewModel.address
        : await me._webShopService.getLocationStreet(me.order.location);
    lastOrderInfo.customerMail = me.order.cusBillMail;
    lastOrderInfo.deliveryAddressViewModel =
      me.service === WebShopMode.Delivery || me.service === WebShopMode.DeliveryGroup
        ? me._webShopService.getDelivaryAddress()
        : null;
    lastOrderInfo.fixedBasket = !me._webShopService.allowBasketModification;
    lastOrderInfo.returnURLSuccess = me._webShopService.returnURLSuccess;
    lastOrderInfo.returnURLFail = me._webShopService.returnURLFail;
    lastOrderInfo.orderedItems = me.order.items
    lastOrderInfo.group_id = me.order.group_id; // group id for remote group orders

    me._checkoutService.setLastOrderInfo(lastOrderInfo);
  }

  //! Bitte bei möglichkeit anpassen, so dass der ExtreneIntent korrekt abgearbeitet wird
  //! app.component.ts führt auch den Checkout intet aus.
  //! die Checkout Componente ist nicht immer offen und es birg die gefahr das 2 mal verarbeitet wird
  //! womöglich ist diese verarbeitung nicht notwendig und es kann alles mit dem Checkoup.Service abgearbeitete
  private onExternIntent(url: string): void {
    const me = this;

    var type: string = null;
    //var done: string = null;
    var token: string = null;
    var params: string = null;

    try {
      if (me._coreCOMService.environment.client.isMobile) {
        url = url.substr(url.indexOf("://"));
        params = url.replace("://", "?");
      } else {
        params = url.substr(url.indexOf("?"));
      }
      const urlParams = new URLSearchParams(params);

      type = urlParams.get("type");
      if (type === "checkout") {
        //done = urlParams.get("done");
        token = urlParams.get("token");
        me._checkoutService.GetStoredCheckoutPaymentModel(token, me._order_id)
          .then((response) => {
            if (response.done === "DoAction") {
              me._coreLogService.error("CheckoutComponent.onExternIntent", "_checkoutService.GetStoredCheckoutPaymentModel done='DoAction'", response);
              me._snackBarService.ShowErrorMessageFailed(15);
            } else {
              // Das native Drop-In muss geschlossen werden, in dem der Response auch abgearbeitet wird.
              let outside: string = urlParams.get("outside");
              if (outside === "true") {
                me.ShowFinalResult(response);
              } else {
                me.HandleDropInPaymentResultNative(response);
              }
            }
          })
          .catch((error) => {
            me._coreLogService.error("CheckoutComponent.onExternIntent", "_checkoutService.GetStoredCheckoutPaymentModel", error);
          });
      }
    } catch (error) {
      this._coreLogService.error("CheckoutComponent.onExternIntent", "parse URLSearchParams (catch)", error);
    }
  }

  /** True when the user is logged in as a registered account. */
  public get isUserRegistered(): boolean {
    const me = this;
    return me._webShopService._userHelperService.IsRegistered;
    }

  //#region Account Payment
  public get isAccountPaymentApproved(): boolean {
    const me = this;
    return me._accountPaymentService.isApproved;
  }

  /** Row state of "Auf Rechnung"; `isUserRegistered` is the only registration source. */
  public get accountPaymentRowState(): AccountPaymentRowState {
    const me = this;
    return me._accountPaymentService.resolveRowState({
      isUserRegistered: me.isUserRegistered,
      isEnabledForOrdertype: me.accountPaymentEnabledForOrdertype,
      isCustomerPaymentOffered: me.show_hs_accounting_customer,
      isLimitBlocked: me.accountPaymentLimitResult.isBlocked,
    });
  }

  public get shouldShowAccountPaymentRow(): boolean {
    const me = this;
    return me.accountPaymentRowState !== AccountPaymentRowState.Hidden;
  }

  /** In-flight, pending and limit-blocked rows are rendered but cannot be operated. */
  public get isAccountPaymentRowDisabled(): boolean {
    const me = this;
    const state = me.accountPaymentRowState;
    return state === AccountPaymentRowState.RequestInFlight
      || state === AccountPaymentRowState.Pending
      || state === AccountPaymentRowState.LimitBlocked;
  }

  public get isAccountPaymentRowChecked(): boolean {
    const me = this;
    return me.accountPaymentRowState === AccountPaymentRowState.Selectable
      && me.selectedPaymentMethod === CheckboxPaymentMethod.Accounting;
  }

  public get isAccountPaymentSingleRowChecked(): boolean {
    const me = this;
    return me.accountPaymentRowState === AccountPaymentRowState.Selectable
      && me.selectedSinglePaymentMethod === me.stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Accounting);
  }

  public get showAvailableCreditHint(): boolean {
    const me = this;
    return me.accountPaymentCreditValues != null && me.accountPaymentCustomer != null && !me.accountPaymentLimitResult.isBlocked;
  }

  /** Triggers a local limit check when the basket total changes and
   *  account payment is visible for the current ordertype. */
  private checkAccountPaymentLimit(): void {
    const me = this;
    if (!me.accountPaymentEnabledForOrdertype || !me.isUserRegistered) { return; }
    if (!me.isAccountPaymentApproved) { return; }
    const basketTotal = me.order ? me.order.paymentAmount : 0;
    me._accountPaymentService.checkLimit(basketTotal);
  }

  private subscribeAccountPaymentStreams(): void {
    const me = this;
    me._accountPaymentService.status$.pipe(takeUntil(me._destroy$)).subscribe(() => {
      me.checkAccountPaymentLimit();
      me.resetAccountPaymentSelectionIfNotSelectable();
      me.PushChanges();
    });
    me._accountPaymentService.limitResult$.pipe(takeUntil(me._destroy$)).subscribe((result) => {
      me.accountPaymentLimitResult = result;
      me.resetAccountPaymentSelectionIfNotSelectable();
      me.PushChanges();
    });
    me._accountPaymentService.creditValues$.pipe(takeUntil(me._destroy$)).subscribe((values) => {
      me.accountPaymentCreditValues = values;
      me.checkAccountPaymentLimit();
      me.PushChanges();
    });
    me._accountPaymentService.accountingCustomer$.pipe(takeUntil(me._destroy$)).subscribe((accountPaymentCustomer) => {
      me.accountPaymentCustomer = accountPaymentCustomer;
      me.PushChanges();
    });
    me._accountPaymentService.activationRequestInProgress$.pipe(takeUntil(me._destroy$)).subscribe(() => {
      me.resetAccountPaymentSelectionIfNotSelectable();
      me.PushChanges();
    });
    me._accountPaymentService.statusLoaded$.pipe(takeUntil(me._destroy$)).subscribe(() => {
      me.resetAccountPaymentSelectionIfNotSelectable();
      me.PushChanges();
    });
  }

  /** Drops a stale "Auf Rechnung" selection (not tracked as a user choice) so the customer has to pick another method. */
  private resetAccountPaymentSelectionIfNotSelectable(): void {
    const me = this;
    if (me.accountPaymentRowState === AccountPaymentRowState.Selectable) { return; }
    if (me.selectedPaymentMethod === CheckboxPaymentMethod.Accounting) {
      me.selectedPaymentMethod = CheckboxPaymentMethod.None;
    }
    if (me.selectedSinglePaymentMethod === me.stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Accounting)) {
      me.selectedSinglePaymentMethod = "";
    }
  }

  /** Pays on account only while the row is still selectable; otherwise aborts silently. */
  private async payWithAccountingIfSelectable(): Promise<void> {
    const me = this;
    if (me.accountPaymentRowState !== AccountPaymentRowState.Selectable) {
      me._coreLogService.info("CheckoutComponent.payWithAccountingIfSelectable", "Account payment aborted: row not selectable", me.accountPaymentRowState);
      return;
    }
    await me.Accounting();
  }

  /** Opens the activation request dialog; only offered while the row is in the request state. */
  public openAccountPaymentRequestDialog(): void {
    const me = this;
    if (me.accountPaymentRowState !== AccountPaymentRowState.RequestDialog) { return; }
    me._accountPaymentRequestDialogService.open(ACCOUNT_PAYMENT_DIALOG_CHANGE_PAYMENT_METHOD_LANGKEY);
  }

  /** Returns true when the click on the "Auf Rechnung" row is fully handled and must not change the selection. */
  private handleAccountPaymentRowClick(event: MatCheckboxChange): boolean {
    const me = this;
    const state = me.accountPaymentRowState;
    if (state === AccountPaymentRowState.Selectable) { return false; }
    me.resetAccountPaymentCheckbox(event);
    if (state === AccountPaymentRowState.RequestDialog) {
      me.openAccountPaymentRequestDialog();
    }
    return true;
  }

  /** MatCheckbox toggles itself before the change event fires; both the component and the native input must be reset. */
  private resetAccountPaymentCheckbox(event: MatCheckboxChange): void {
    event.source.checked = false;
    const inputElement = event.source._inputElement;
    if (inputElement && inputElement.nativeElement) {
      inputElement.nativeElement.checked = false;
    }
  }

  //#endregion Account Payment

  public UseWebVoucher(cardnr: string): Promise<GetWebVoucherDataModel> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    const locationID = me._webShopService.getServiceLocation();
    return new Promise<GetWebVoucherDataModel>(async (resolve, reject) => {
      if (me.canUseWebvoucher) {
        me._webVoucherService
          .GetWebVoucherForLocation(cardnr, locationID)
          .then((response) => {
            me._overlaySpinnerService.HideLayoutSpinner();
            if (response.success) {
              if (me.order !== null) {
                // todo forübergehend werden im InHouse keine Gutschein Rabatte angewandt
                //! achtung checkout.component.ts UseWebVoucher beachten, hat selbe prüfung
                if (
                  response.discount_bonus > 0 &&
                  me._webShopService.getServiceMode() === WebShopMode.OrderToTable &&
                  !Number.isNaN(me._inHouseOrderService.TableData.location) &&
                  !me._inHouseOrderService.TableData.mandatory_Payment
                ) {
                  // todo wenn rabatte berücksichtigt werden, kann es ausgebaut werden
                  /** Momentan ist es nicht möglich digital mit einem Gutschein zu bezahlen */
                  me.openVoucherCannotBeUsed();
                  reject();
                  return;
                } // else in mandatory_Payment (PayNow) wird OrdarAndPay ausgeführt, damit ist dem Gast möglich Rabatt zu nutzen
                me.order.partialpaymentInfo = response.cardnumber;
                me.hasWebvoucher = true;
                me.webvoucherBalance = response.balance;
                me.webvoucherBalanceBonus = response.balance_bonus;
                me.webvoucherDiscount = response.discount_bonus;
                me.webvoucherCardNr = response.cardnumber;
                me.setWebVoucherInfoHtml();
                me._webShopService.setDiscounts({
                  webvoucherDiscount: me.webvoucherDiscount,
                });
                me.PushChanges();
                me.TryGetPaymentMethods(me.order).then(/* run it async */);
              } else {
                me._coreLogService.error(
                  "CheckoutComponent.tryWebvoucherCardNr",
                  "No Order found"
                );
                reject();
                return;
              }
            } else {
              // Todo Notify User of Incorrect CardNr
            }
            resolve(response);
          })
          .catch((error) => {
            me._overlaySpinnerService.HideLayoutSpinner();
            me._coreLogService.error(
              "CheckoutComponent.tryWebvoucherCardNr",
              "_webVoucherService.GetWebVoucher",
              error
            );
            reject();
          });
      } else {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._coreLogService.error(
          "CheckoutComponent.UseWebVoucher",
          "can not use webvoucher"
        );
        reject();
      }
    });
  }

  // This never gets called, replaced by setUseWebvoucher, mabye remove
  public PayWithWebVoucher(): void {
    const me = this;
    if (me.order !== null) {
      if (me.hasWebvoucher) {
        const fullcardbalance = me.webvoucherBalanceTotal;
        // versuche voll mit gutschein zu bezahlen
        me.order.partialPaymentAmount = Utils.moneyRound(
          me.order.grossprice > fullcardbalance
            ? fullcardbalance
            : me.order.grossprice
        );
        me.order.paymentAmount = Utils.moneyRound(
          me.order.grossprice - me.order.partialPaymentAmount
        );
      } else {
        // "Keine WebVoucher gefunden";
      }
    } else {
      // "Keine Bestellung für WebVoucherCode gefunden";
    }
    me.PushChanges();
  }

  private GetFakeOrder(): AddPurchaseOrderDataModel {
    const order = new AddPurchaseOrderDataModel();
    order.location = 10001;
    order.grossprice = 12.0;
    order.cusGuest = true;
    order.ordertype = orderTypes.delivery;
    order.items = [new AddPurchaseOrderItemDataModel()];
    order.items[0].product_id = 12;
    order.items[0].usingtype = 2;
    order.items[0].comment = "test";
    order.currencySymbol = "€";
    order.cusBillCountry = "Deutschland";
    return order;
  }

  /** Zahlung am POS ist nur für InHouse-Bestellungen mit Zahlungszwang, Betrag > 0 und an nicht ausgeschlossenen Standorten möglich */
  private get isPayAtWaiterOffered(): boolean {
    const me = this;
    return (
      me._webShopService.ordertype.model.id === orderTypes.inHouse &&
      me._inHouseOrderService.TableData.mandatory_Payment &&
      me._webShopService.isPayAtWaiterAvailable &&
      me.order.paymentAmount > 0
    );
  }

  private async TryGetPaymentMethods(addPurchaseOrder: AddPurchaseOrderDataModel = null) {
    const me = this;

    me._overlaySpinnerService.ShowLayoutSpinner();
    me.order = addPurchaseOrder || me.GetFakeOrder();
    let ih_data: InHouseDataModel = null;
    if (me.in_house) {
      ih_data = me._inHouseOrderService.GetInHouseDataModelForCheckout();
      await me._inHouseOrderService.SyncConnectionWithServer();
    }
    const webshopSettings = await me._webShopService.getWebshopSettingsDataModel().catch(() => null);

    me._checkoutService
      .GetPaymentMethodsFromServer(me.order, ih_data)
      .then((response) => {
        const payments = response.payments;
        me.splitPaymentMethods = response.splitPaymentMethods;
        me.show_adyen = false; // SIDEEFFECT affected! Is activated in PrepareDropIn, so it is only shown when the DropIn could be initialized
        me.show_hs_webvoucher = payments.includes("hs_webvoucher");
        me.show_hs_pay_at_waiter = me.isPayAtWaiterOffered;
        me.show_hs_cash = payments.includes("hs_cash");
        me.show_hs_cashless = payments.includes("hs_cashless");
        me.show_hs_accounting = payments.includes("hs_accounting");
        me.show_hs_accounting_customer = payments.includes("hs_accounting_cus");
        me._accountPaymentEnabledForOrdertype = webshopSettings != null
          ? me._accountPaymentService.isEnabledForOrdertype(webshopSettings, me.order.ordertype)
          : false;
        me.resetAccountPaymentSelectionIfNotSelectable();
        if (me.accountPaymentEnabledForOrdertype && me.isUserRegistered) {
          me._accountPaymentService.loadStatus();
          me._accountPaymentService.loadCreditInfo();
        }
        me.show_hs_paypal = payments.includes("hs_paypal");
        const hasAdyen = payments.includes("adyen");
        const hasWallee = payments.includes("wallee");

        if (hasAdyen) {
          me.PrepareDropIn(response); // SIDEEFFECT: sets me.show_adyen to true, if needed
          me.adyenPaymentIcons = me.getPaymentIconsFromCheckoutPaymentMethodsModel(response);

          if (this.useSplitPaymentMethods) {
            me.adyenPaymentMethods = me.convertAdyenPaymentMethods(me.extractAdyenPaymentMethods(response)).sort().reverse();
          }
        } else if (hasWallee) {
          me.PrepareWallee(response);
        }
        me.isInitialised = true;
        me.setWebVoucherInfoHtml();
        me.checkAccountPaymentLimit();
      }).then(() => {
        me.PushChanges();
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch((error) => {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._coreLogService.error(
          "CheckoutComponent.TryGetPaymentMethods",
          "_checkoutService.GetPaymentMethodsFromServer",
          error
        );
      });
    me.PushChanges(); // todo ist es hier wirklich notwendig
  }

  private extractAdyenPaymentMethods(response: CheckoutPaymentMethodsModel): any {
    return (response && response.PaymentMethods && response.PaymentMethods.paymentMethods) ? response.PaymentMethods.paymentMethods : [];
  }

  private convertAdyenPaymentMethods(paymentMethods: Array<any>): Array<PaymentMethod> {
    const result: Array<PaymentMethod> = [];
    if (paymentMethods) {
      for (const pm of paymentMethods) {
        const paymentMethodName = this._internationalisationService.getLocaleValue(this._internationalisationService.getCurrentLocale(), "phPayment_MethodName_" + pm.type);

        let paymentMethod = {
          details: pm.details ? pm.details : [],
          name: paymentMethodName !== pm.type ? paymentMethodName : pm.name, // If the key is the result of the lookup a value is not present and therefore the pm.name must be used.
          type: pm.type,
          brands: pm.brands ? pm.brands : [],
          icons: [],
        };

        if (this.isCreditCard(pm.type)) {
          if (pm.brands) {
            paymentMethod.icons.push(...pm.brands);
          }
        } else {
          paymentMethod.icons.push(pm.type);
        }

        if (this.isGooglePay(pm.type) && this.isIOS()) {
          // IGNORE GOOGLEPAY FOR IOS
        } else {
          result.push(paymentMethod);
        }
      }
    }
    return result;
  }

  private isApplePayAvailableInDropInOptions(dropInOptions: any): boolean {
    return dropInOptions &&
      dropInOptions.paymentMethodsResponse &&
      dropInOptions.paymentMethodsResponse.paymentMethods &&
      dropInOptions.paymentMethodsResponse.paymentMethods.filter(pm => this.APPLE_PAY_TYPE === pm.type).length === 1;
  }

  /** Prüfung, ob ApplePay vom Adyen DropIn unterstützt wird
   * @param checkout AdyenCheckout
   */
  public async isApplePaySupported(checkout: any): Promise<boolean> {
    const me = this;
    try {
      const applePayComponent = checkout.create(me.APPLE_PAY_TYPE);
      if (applePayComponent.isAvailable) {
        return await applePayComponent.isAvailable();
      } else {
        return false;
      }
    } catch (error) {
      me._coreLogService.error("CheckoutComponent.isApplePaySupported", "catch", error);
      return false;
    }
  }


  private removePaymentMethodFromDropInOptions(adyenDropInOptions: any, paymentMethodType: string): any {
    const inequality = (x: string, y: string) => { return x !== y; };
    return this.editDropInOptions(adyenDropInOptions, paymentMethodType, inequality);
  }

  private editDropInOptions(adyenDropInOptions: any, paymentMethodType: string, operation: (x: string, y: string) => boolean): any {
    const result = _.cloneDeep(adyenDropInOptions);
    result.paymentMethodsResponse.paymentMethods = adyenDropInOptions.paymentMethodsResponse.paymentMethods.filter(paymentMethod => operation(paymentMethod.type, paymentMethodType));

    if (!this.isCreditCard(paymentMethodType)) {
      result.paymentMethodsResponse.groups = [];
      delete result.paymentMethodsConfiguration.card;
    }

    if (!this.isApplePay(paymentMethodType)) {
      delete result.paymentMethodsConfiguration.applepay;
    }

    if (!this.isGooglePay(paymentMethodType)) {
      delete result.paymentMethodsConfiguration.googlepay;
    }
    return result;
  }

  private isCreditCard(type: string): boolean {
    return this.CREDIT_CARD_TYPE === type;
  }

  private isApplePay(type: string): boolean {
    return this.APPLE_PAY_TYPE === type;
  }

  private isGooglePay(type: string): boolean {
    return this.GOOGLE_PAY_TYPE === type;
  }

  private readTransactionToken(response: CheckoutPaymentMethodsModel) {
    const configdata = JSON.parse(response.config_json);
    return configdata.transaction_token;
  }

  private readPaymentMethods(response: CheckoutPaymentMethodsModel): WalleePaymentMethod[] {
    const paymentdata = JSON.parse(response.json);
    const payment_methods = paymentdata.payment_methods;

    var result: WalleePaymentMethod[] = new Array();

    payment_methods.forEach((paymentMethod) => {
      result.push({
        connectorId: paymentMethod.ConnectorId,
        paymentMethodId: paymentMethod.PaymentMethodId,
        name: paymentMethod.NameTable.en,
        imageUrl: paymentMethod.ImageUrl,
      });
    });

    return result;
  }

  private PrepareWallee(response: CheckoutPaymentMethodsModel) {
    const me = this;
    me._walleeTransactionToken = this.readTransactionToken(response);
    me.walleePaymentMethods = this.readPaymentMethods(response);
    me.show_wallee = me.walleePaymentMethods.length > 0;
  }

  private injectScript(url: string): Promise<void> {
    if (!this.isScriptLoaded(url)) {
      return new Promise<void>((resolve) => {
        const script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", url);
        script.setAttribute("async", "");
        script.onload = () => {
          resolve();
        };
        script.onerror = (error: any) => {
          this._coreLogService.error("CheckoutComponent.injectScript", "Error with " + url, error);
          resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
      });
    } else {
      return Promise.resolve();
    }

  }

  private isScriptLoaded(url: string): boolean {
    return document.querySelector(`script[src="${url}"]`) !== null;
  }

  public async Webvoucher(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const response = await me._MakePaymentOnServer("hs_webvoucher", null);
      await me.setOrderID(response.order_id, response.order_token);
      me.ShowFinalResult(response);
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error(
        "CheckoutComponent.Webvoucher",
        "try catch",
        error
      );
    }
  }

  /** Zahlung am POS (Orderbon wird bei dieser Zahlungsmethode nicht ausgelöst, erst bei Zahlung am POS) */
  public async PayAtWaiter(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      if (me.in_house) {
        const ih_data = me._inHouseOrderService.GetInHouseDataModelForCheckout();
        // PaymentSelect wird hier gestartet, da es sich um einen OrderAndPay handelt, bei dem Zahlung am POS ausgeführt wird
        // eine Bestellung ohne Orderbon bis zur Zahlung am POS
        await me._inHouseOrderService.StartPaymentSelect();
        const response = await me._MakePaymentOnServer("hs_pay_at_waiter", null);
        await me.setOrderID(response.order_id, response.order_token);
        // Bei Zahlung am Tisch wird die Tischnummer mitgegeben für den QR-Code
        if (response.done === ResponseCode_Done.Authorised) {
          // Ungenutzte Action wird zur Datenübertragung gentzt
          response.action_json = JSON.stringify({
            type: "pay_at_waiter",
            table_no: ih_data.table_no,
          });
          // Zahlungswunsch erfolgreich übertragen, Verbindung zum Tisch komplett trennen
          try {
            await me._inHouseOrderService.CloseTableAndCleanUpAfterPayAtWaiter();
          } catch (error) {
            me._coreLogService.error("CheckoutComponent.PayAtWaiter", "CloseTableAndCleanUpAfterPayAtWaiter", error);
          }
        }
        me.ShowFinalResult(response);
        await me._inHouseOrderService.SyncConnectionWithServer();
      }
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("CheckoutComponent.PayAtWaiter", "try catch", error);
      // PaymentSelect abbrechen, um Tisch am POS freizugeben
      await me._inHouseOrderService.AbortPaymentSelect();
    }
  }

  public async Cash(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const response = await me._MakePaymentOnServer("hs_cash", null);
      await me.setOrderID(response.order_id, response.order_token);
      me.ShowFinalResult(response);
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("CheckoutComponent.Cash", "try catch", error);
    }
  }

  public async Cashless(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const response = await me._MakePaymentOnServer("hs_cashless", null);
      await me.setOrderID(response.order_id, response.order_token);
      me.ShowFinalResult(response);
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error(
        "CheckoutComponent.Cashless",
        "try catch",
        error
      );
    }
  }

  private async Accounting(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const response = await me._MakePaymentOnServer("hs_accounting_cus", null);
      await me.setOrderID(response.order_id, response.order_token);
      me.ShowFinalResult(response);
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("CheckoutComponent.Accounting", "try catch", error);
    }
  }

  public async PayPal(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const response = await me._MakePaymentOnServer("hs_paypal", null);
      await me.setOrderID(response.order_id, response.order_token);
      if (response.done === "DoAction") {
        const action = JSON.parse(response.action_json);
        if (action.url) {
          if (me._coreCOMService.environment.client.isMobile) {
            window.open(action.url, "_system"); // _system > öffnet system browser vom smartphone zu öffnen
          } else {
            window.location = action.url;
          }
          // Timeout, since the opening of the window takes time. In Practice it shouldn't even be needed since we open in the same window.
          setTimeout(() => {
            me._overlaySpinnerService.HideLayoutSpinner();
          }, 5000);
        } else {
          me._overlaySpinnerService.HideLayoutSpinner();
          throw Error("wrong action");
        }
      } else {
        me.ShowFinalResult(response);
      }
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("CheckoutComponent.PayPal", "try catch", error);
    }
  }

  private async Wallee(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      let data = {
        walleePaymentInformation: {
          transaction_token: me._walleeTransactionToken,
        },
      };
      const response = await me._MakePaymentOnServer("wallee", data);
      await me.setOrderID(response.order_id, response.order_token);

      me._walleeTransactionToken = ""; // remove confirmed transaction

      if (response.done === "DoAction") {
        const action = JSON.parse(response.action_json);
        await me.injectScript(action.javascript_url);

        if (LightboxCheckoutHandler) {
          // if successful dont hide the LayoutSpinner, because the lightbox redirects in all cases!
          // Calling startPayment forces the user to decide for a payment method. While checkout we cant decide which extra payment method shall be used.
          LightboxCheckoutHandler.startPayment(null, () => {
            me._overlaySpinnerService.HideLayoutSpinner();
            me._coreLogService.error(
              "CheckoutComponent.Wallee",
              "LightboxCheckoutHandler startPayment failed"
            );
            me._snackBarService.ShowErrorMessageFailed(16);
          });
        } else {
          me._overlaySpinnerService.HideLayoutSpinner();
          me._coreLogService.error(
            "CheckoutComponent.Wallee",
            "LightboxCheckoutHandler is undefined"
          );
          me._snackBarService.ShowErrorMessageFailed(17);
        }
      } else {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._coreLogService.error(
          "CheckoutComponent.Wallee",
          "unknown response",
          response
        );
        me._snackBarService.ShowErrorMessageFailed(18);
      }
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("CheckoutComponent.Wallee", "try catch", error);
    }
  }

  private async _MakePaymentOnServer(
    type:
      | "adyen"
      | "wallee"
      | "hs_webvoucher"
      | "hs_pay_at_waiter"
      | "hs_cash"
      | "hs_cashless"
      | "hs_accounting"
      | "hs_accounting_cus"
      | "hs_paypal",
    data: any
  ): Promise<CheckoutPaymentModel> {
    const me = this;
    if (me._isProcessingOrder) {
      throw new Error("Already Processing Order");
    } else {

      if (this.needsAddressCheck() && !this.hasAnyAddress()) {
        this._snackBarService.ShowMessage(me._coreLanguageService.value("phPayment_NoDeliveryAddress"), SnackBarMessageType.Error);
        throw new Error("Missing delivery & billing address");
      }

      me._isProcessingOrder = true;
      try {
        let ih_data: InHouseDataModel = null;
        if (me.in_house) {
          ih_data = me._inHouseOrderService.GetInHouseDataModelForCheckout();
          me._inHouseOrderService.suppressNextTableClosedWarning = true; // todo überarbeiten
          await me._inHouseOrderService.SyncConnectionWithServer();
        }

        try {
          const checkoutPaymentModel =
            await me._checkoutService.MakePaymentOnServer(
              type,
              me.order,
              ih_data,
              data
            );
          me._isProcessingOrder = false;
          this.trackInitiateCheckout(type, this.order.items);
          return checkoutPaymentModel;
        } catch (make_payment_error) {
          me._isProcessingOrder = false;
          await me.HandlePaymentError(make_payment_error);
          throw make_payment_error;
        }
      } catch (error) {
        me._isProcessingOrder = false;
        throw error;
      }
    }
  }

  private needsAddressCheck(): boolean {
    return this.order.ordertype == orderTypes.delivery
      || this.order.ordertype == orderTypes.deliveryGroup
      || this.order.ordertype == orderTypes.retail;
  }

  private hasAnyAddress(): boolean {
    return (
      (this.order && this.order.cusDeliveryAdress && this.order.cusDeliveryAdress.trim().length > 0) ||
      (this.order && this.order.cusBillAdress && this.order.cusBillAdress.trim().length > 0)
    );
  }

  private trackInitiateCheckout(type: string, items: AddPurchaseOrderItemDataModel[]): void {
    this._trackingManager.trackInitiateCheckout(
      type,
      items,
      this._webShopService.currencySymbol,
      this._webShopService.getBasketSumTotal()
    );
  }

  /**
   * Anhand vom Fehler Code Text wird entsprechende Information an den Anwender ausgegeben.
   * Wenn die Ursache von Fehlerhaften Daten ist, kann der Anwender den Warenkorb zurücksetzen.
   */
  private async HandlePaymentError(code_text: string): Promise<void> {
    const me = this;
    let error_code = 0;
    // parse error code from "intern error: XXX"
    if (code_text.includes(":")) {
      error_code = +(code_text.split(":")[1]);
    }

    let resetBasket = false;
    switch (error_code) {
      case PaymentErrorCode.NoItems:
      case PaymentErrorCode.NoRequestData:
      case PaymentErrorCode.InvalidRequest:
      case PaymentErrorCode.ValidationError:
      case PaymentErrorCode.GrosspriceWrong:
      case PaymentErrorCode.Multiple_Order:
        resetBasket = true;
        break;
      case PaymentErrorCode.UndefinedError:
      case PaymentErrorCode.NoAccountID:
      case PaymentErrorCode.ResponseIsEmpty:
      case PaymentErrorCode.ResponseDataIsEmpty:
      case PaymentErrorCode.ResponseDataSetIsEmpty:
      case PaymentErrorCode.DataRecordCreationNotpossible:
      case PaymentErrorCode.UnKnownConnectorError:
        resetBasket = false;
        break;
      default:
        me._coreLogService.error("CheckoutService.HandlePaymentError", "Unknown error_code", error_code);
        resetBasket = false;
        break;
    }

    if (resetBasket) {
      me.openPaymentErrorDialog(error_code === PaymentErrorCode.Multiple_Order);
      // parallel zum Dialog auch die Daten aktuallisieren
      try {
        const location = me._webShopService.locationID;
        const sortimet = me._webShopService.sortiment;
        // navigate to home
        await me._router.navigate([""]); // "" > home
        // clean up Cache
        await me._productService.DeleteLocalLocationProductData(location, sortimet);
        // clean up Basket
        me._webShopService.resetWebshopService();
        // clean up selected Time
        await me._webShopService.removeCachedServiceTime();
        // load Cache
        const _ = await me._productService.GetProductLastSyncAt(location, sortimet);
      } catch (error) {
        me._coreLogService.error("CheckoutService.HandlePaymentError", "ResetBasket error", error);
      }
    } else {
      me._MatDialog.open(ErrorDialogComponent, {
        data: {
          title: "phErrorMessage_Title",
          description: "phErrorMessage_Text_Checkout",
        },
        panelClass: "error-dialog-styles",
      });
    }
  }

  public getPathToAdyenSvg(name: string): string {
    return `adyenpmicons/${name}.svg`;
  }

  public getPathToCheckoutSvg(name: string): string {
    return `checkout/${name}.svg`;
  }

  /** Zeigt das Adyen DropIn für die Zahlung an */
  private Adyen(): void {
    const me = this;
    switch (me.getClientType()) {
      case ClientType.browser:
        me.toggleWebDropInVisibility(true);
        break;
      case ClientType.android: // android und ios zusammen
      case ClientType.ios:
        const adyenDropInConfiguration = this.useSplitPaymentMethods ? me._filteredAdyenDropInOptions : me._adyenDropInOptions;
        Adyen.presentDropIn(adyenDropInConfiguration, _ => { }, error => { me.raiseError("Adyen.onError", "parameters", error); });
        break;
      default:
        break;
    }
  }

  /** schaltet den WebDropIn bereich ein und Checkout damit aus */
  public toggleWebDropInVisibility(show: boolean) {
    const me = this;
    me.showWebDropIn = show;
    me.PushChanges();
  }

  /** führt den ersten Zahlungsvorgang über Adyen durch */
  private MakeAdyenPayment(dropin_data: any): Promise<CheckoutPaymentModel> {
    const me = this;
    // Wenn mit Karte bezahlt wird, muss der ermitelte Kartentyp/Brand mit übergeben werden
    if (this.isCreditCard(dropin_data.paymentMethod.type)) {
      dropin_data.paymentMethod.brand = me.dropin_last_cardbrand;
    }
    return me._MakePaymentOnServer("adyen", dropin_data);
  }

  /**
   * Führt den erweiterten Zahlungsvorgang über Adyen durch.
   */
  private async MakeAdyenPaymentDetails(dropin_data: any): Promise<CheckoutPaymentModel> {
    const me = this;

    // todo cache ih_data
    let ih_data: InHouseDataModel = null;

    if (me.in_house) {
      ih_data = me._inHouseOrderService.GetInHouseDataModelForCheckout();
      me._inHouseOrderService.suppressNextTableClosedWarning = true; // todo überarbeiten
      await me._inHouseOrderService.SyncConnectionWithServer();
    }

    return me._checkoutService.MakeAdyenPaymentDetailsOnServer(me.order.location, me._order_id, ih_data, dropin_data);
  }

  /** verarbeitet die Antwort des Zahlungsvorgangs aus (für den Web-DropIn) */
  private HandleWebDropInPaymentResult(
    response: CheckoutPaymentModel,
    dropin: any
  ) {
    const me = this;
    me._overlaySpinnerService.HideLayoutSpinner();
    if (response.action_json) {
      dropin.setStatus("ready");
      // Drop-in handles the action object from the /payments response
      dropin.handleAction(JSON.parse(response.action_json));
    } else {
      me.ShowFinalResult(response);
    }
  }

  private ShowFinalResult(result: CheckoutPaymentModel): void {
    const me = this;
    me._overlaySpinnerService.HideLayoutSpinner();
    me._checkoutService.ShowFinalResult(result);
  }

  /** Cache of ClientKeyCache for GetClientKey */
  private ClientKeyCache: { [key: string]: string } = {}; // nicht vorhalten, da es von Adyen Client-Side Encryption abhängt

  /** Gets ClientKey, first from ClientKeyCache, else from Server */
  public GetClientKey(): Promise<string> {
    const me = this;
    const origin = window.location.origin;
    if (me.ClientKeyCache[origin]) {
      return Promise.resolve<string>(me.ClientKeyCache[origin]);
    } else {
      return new Promise<string>((resolve, reject) => {
        try {
          me._checkoutService
            .GenerateOriginKey(origin)
            .then((response) => {
              me.ClientKeyCache[origin] = response.client_key;
              resolve(me.ClientKeyCache[origin]);
            })
            .catch((error) => {
              me._coreLogService.error(
                "CheckoutComponent.GetClientKey",
                "_checkoutService.GenerateOriginKey()",
                error
              );
              reject();
            });
        } catch (error) {
          me._coreLogService.error(
            "CheckoutComponent.GetClientKey",
            "try catch",
            error
          );
          reject();
        }
      });
    }
  }

  /** Cache of PublicKey for GetPublicKey */
  private PublicKeyCache: string = ""; // nicht vorhalten, da es von Adyen Client-Side Encryption abhängt

  /** Gets GetPublicKey, first from PublicKeyCache, else from Server */
  public GetPublicKey(): Promise<string> {
    const me = this;

    if (me.PublicKeyCache.length > 0) {
      return Promise.resolve<string>(me.PublicKeyCache);
    } else {
      return new Promise<string>((resolve, reject) => {
        try {
          me._checkoutService
            .GetPublicKey()
            .then((response) => {
              me.PublicKeyCache = response.public_key;
              resolve(me.PublicKeyCache);
            })
            .catch((error) => {
              me._coreLogService.error(
                "CheckoutComponent.GetPublicKey",
                "_checkoutService.GetPublicKey()",
                error
              );
              reject();
            });
        } catch (error) {
          me._coreLogService.error(
            "CheckoutComponent.GetPublicKey",
            "try catch",
            error
          );
          reject();
        }
      });
    }
  }

  /** Ermittelt die möglichen Zahlungsarten über Adyen */
  private getPaymentIconsFromCheckoutPaymentMethodsModel(model: CheckoutPaymentMethodsModel): string[] {
    let icons = [];
    if (model && model.PaymentMethods && model.PaymentMethods.paymentMethods) {
      for (const pm of model.PaymentMethods.paymentMethods) {
        if (this.isCreditCard(pm.type)) {
          if (pm.brands) {
            icons = icons.concat(pm.brands);
          }
        } else {
          if (this.isGooglePay(pm.type) && this.isIOS()) {
            // IGNORE GOOGLEPAY FOR IOS
          } else {
            icons.push(pm.type);
          }
        }
      }
    }
    return icons;
  }

  /** Bereitet die Adyen Daten für das DropIn vor
   * @param response Adyen Server PaymentMethods Response
   */
  private PrepareDropIn(response: CheckoutPaymentMethodsModel) {
    const me = this;
    const paymentMethodsResponse = response.PaymentMethods;
    const paymentMethodsConfiguration = response.PaymentMethodsConfig;

    me._adyenDropInOptions = {
      paymentMethodsResponse: paymentMethodsResponse,
      paymentMethodsConfiguration: paymentMethodsConfiguration,
      showPayButton: true, // leider ist default "false" und nicht wie in doku "true"
      environment: env.checkout_in_test_mode ? "test" : "live",
      locale: me._coreLanguageService.getCurrentLanguage(),
      analytics: {
        enabled: false // not send analytics data to Adyen yet
      },
      countryCode: paymentMethodsConfiguration.countryCode, // iOS nutzt es (das land des shopers?)
      amount: paymentMethodsConfiguration.amount, // iOS benötigt es für ApplePay
    };

    // Der Browser nutzt das DropIn von Adyens Javascript, die Apps nutzen die native Implementation des Cordova Plugins
    switch (me.getClientType()) {
      case ClientType.browser:
        if (AdyenCheckout) {
          me.addStylingToInputFields(paymentMethodsConfiguration);

          if (paymentMethodsConfiguration.card) {
            paymentMethodsConfiguration.card.onBrand = function brandChanged(data) {
              me.dropin_last_cardbrand = data.brand;
            };
          }

          if (paymentMethodsConfiguration.applepay) {
            paymentMethodsConfiguration.applepay.onValidateMerchant = function (
              resolve,
              reject,
              validationURL
            ) {
              // Calls your server with validationURL, which then requests a payment session from Apple Pay servers.
              // Your server then receives the session and calls resolve(MERCHANTSESSION) or reject() to complete merchant validation.
              me._checkoutService
                .GetApplePaySessionFromServer(response.location, validationURL)
                .then((response) => {
                  resolve(JSON.parse(response.session_json));
                })
                .catch(reject);
            };

            // applepay needs to overwrite onSubmit, else it wount call dropin.onSubmit
            paymentMethodsConfiguration.applepay.onSubmit = (state, dropin) => {
              me._adyenDropInOptions.onSubmit(state, dropin);
            };
            // like onSubmit
            paymentMethodsConfiguration.applepay.onError = (error) => {
              me._adyenDropInOptions.onError(error);
            };
          }

          me._adyenDropInOptions.onSubmit = (state, dropin) => {
            // Dropin lässt unbekannte Kartentypen durch, wenn die Kartennummer gültig ist => Prüfen, Meldung an User und abbrechen
            if (
              me.isCreditCard(state.data.paymentMethod.type) &&
              me.dropin_last_cardbrand === "card"
            ) {
              me.openUnsupportedCardTypeDialog();
              dropin.setStatus("ready");
              return;
            }
            dropin.setStatus("loading");
            me._overlaySpinnerService.ShowLayoutSpinner();
            me.PushChanges();
            // Your function calling your server to make the `/payments` request
            me.MakeAdyenPayment(state.data)
              .then((response) => {
                me.setOrderID(response.order_id, response.order_token)
                  .then(() => {
                    me.HandleWebDropInPaymentResult(response, dropin);
                  })
                  .catch((e) => {
                    me._overlaySpinnerService.HideLayoutSpinner();
                    // todo show error
                    me._coreLogService.error(
                      "CheckoutComponent.PrepareDropIn",
                      "setOrderID",
                      e
                    );
                  });
              })
              .catch((error) => {
                me._overlaySpinnerService.HideLayoutSpinner();
                dropin.setStatus("error", { message: "Something went wrong." });
                me._coreLogService.error(
                  "CheckoutComponent.PrepareDropIn",
                  "MakeAdyenPayment",
                  error
                );
                me._snackBarService.ShowErrorMessageFailed(19);
              });
          };

          me._adyenDropInOptions.onAdditionalDetails = (state, dropin) => {
            dropin.setStatus("loading");
            me._overlaySpinnerService.ShowLayoutSpinner();
            me.PushChanges();
            // Your function calling your server to make a `/payments/details` request
            me.MakeAdyenPaymentDetails(state.data)
              .then((response) => {
                me.HandleWebDropInPaymentResult(response, dropin);
              })
              .catch((error) => {
                me._overlaySpinnerService.HideLayoutSpinner();
                dropin.setStatus("error", { message: "Something went wrong." });
                me._coreLogService.error(
                  "CheckoutComponent.PrepareDropIn",
                  "MakeAdyenPaymentDetails",
                  error
                );
                me._snackBarService.ShowErrorMessageFailed(20);
              });
          };

          me._adyenDropInOptions.onError = (error) => {
            me._overlaySpinnerService.HideLayoutSpinner();
            me._coreLogService.error(
              "CheckoutComponent.PrepareDropIn",
              "_adyenDropInOptions.onError",
              error
            );
            me._snackBarService.ShowErrorMessageFailed(21);
          };

          me.GetClientKey()
            .then(async clientKey => {
              me._adyenDropInOptions.clientKey = clientKey;
              await me.prepareGooglePay(paymentMethodsConfiguration);

              me._adyenCheckout = await new AdyenCheckout(me._adyenDropInOptions);
              await me.verifyApplePayConfigurations(me._adyenCheckout);
              me.mountAdyenDropIn(me._adyenCheckout, "dropin");
              me.show_adyen = true;
              me.PushChanges();
            })
            .catch((error) => {
              me.show_adyen = false;
              me._coreLogService.error("CheckoutComponent.PrepareDropIn", "GetClientKey()", error);
              me._snackBarService.ShowErrorMessageFailed(23);
            });
        } else {
          me.show_adyen = false;
        }
        break;
      case ClientType.android:
      case ClientType.ios:
        if (!me.isAdyenPluginLoaded()) {
          me.show_adyen = false;
          me.raiseError("PrepareDropIn", "Adyen plugin is not loaded!");
        } else {
          me.GetClientKey()
            .then((clientKey) => {
              me._adyenDropInOptions.clientKey = clientKey;
              me._adyenDropInOptions.onSubmit = me.onSubmitNative.bind(me);
              me._adyenDropInOptions.onAdditionalDetails = me.onAdditionalDetailsNative.bind(me);
              me.show_adyen = true;
              me.PushChanges();
            })
            .catch((error) => {
              me.show_adyen = false;
              me.raiseError("PrepareDropIn", "GetClientKey()", error);
            });
        }
        break;
      default:
        me.raiseError("PrepareDropIn", "Unsupported ClientType for Adyen DropIn", me.getClientType());
        break;
    }
  }

  private isAdyenPluginLoaded(): boolean {
    return typeof Adyen !== undefined;
  }

  /**
   * Dieser Callback wird aufgerufen nachdem ein Nutzer eine Zahlungsart im nativen DropIn ausgewählt hat.
   * Es muss die Verarbeitung der Zahlung gestartet werden. Die Antwort wird dem Adyen Plugin bei Erfolg mitgegeben.
   */
  private onSubmitNative(state): void {
    const me = this;

    if (this.isSelectedPaymentOptionCompatibleWithPOS(state)) {
      me.MakeAdyenPayment(state.data)
        .then((response) => {
          me.setOrderID(response.order_id, response.order_token)
            .then(() => {
              me.HandleDropInPaymentResultNative(response);
            }).catch((error) => {
              me.triggerErrorNative("Fehler - Die Bestellungsnummer konnte nicht verarbeitet werden.", "onSubmitNative", "setOrderID", error);
            });
        }).catch((error) => {
          me.triggerErrorNative("Fehler - Die Zahlung konnte nicht übertragen werden.", "onSubmitNative", "MakeAdyenPayment", error);
        });
    } else {
      if (me.isAndroid()) {
        // The native DropIn shows an AlertBox and the only way to dismiss correctly is to finish the DropIn.
        Adyen.successDropIn();
      } else {
        // IOS is able to dismiss directly
        Adyen.errorDropIn("Selected card is not supported by our system, but was deliverd by Adyen.");
      }
      me.openUnsupportedCardTypeDialog();
    }
  }

  /**
   * Prüft die zuletzt genutzte Kreditkarte.
   * Dies ist notwendig, weil das DropIn Karten akzeptiert, die am POS nicht kompatibel sind.
  */
  private isSelectedPaymentOptionCompatibleWithPOS(state) {
    const me = this;

    if (state.data.last_card_brand && state.data.last_card_brand.length > 0) {
      me.dropin_last_cardbrand = state.data.last_card_brand;
    }
    return !(me.isCreditCard(state.data.paymentMethod.type) && me.dropin_last_cardbrand === "card");
  };

  private triggerErrorNative(reason: string, rootCallbackName: string, failedMethodName: string, error: any): void {
    Adyen.errorDropIn(reason);
    this.raiseError(rootCallbackName, failedMethodName, error);
  }

  private raiseError(callingMethodName: string, errorMessage: string, error: any = undefined): void {
    const rootOfError = "CheckoutComponent." + callingMethodName;

    if (error) {
      this._coreLogService.error(rootOfError, errorMessage, error);
    } else {
      this._coreLogService.error(rootOfError, errorMessage);
    }

    this._snackBarService.ShowErrorMessageFailed(24);
  }

  /**
   *  Verarbeitet die Antwort des Zahlungsvorgangs im nativen DropIn auf Android oder iOS.
   *  Falls eine weitere Aktion nötig ist, wird dies dem DropIn migegeben, damit es sich korrekt verhält.
   *  Falls keine weitere Aktion nötig ist, wird dem DropIn der Erfolg mitgeteilt und die Erfolgsmeldung auf der Browserseite wird gestartet.
   */
  private HandleDropInPaymentResultNative(response: CheckoutPaymentModel): void {
    if (response.action_json) {
      Adyen.handleAction(JSON.parse(response.action_json));
    } else {
      Adyen.successDropIn(response.done); // todo das darf nicht umleiten
      this.ShowFinalResult(response);
    }
  }

  /**
   * Dieser Callback wird aufgerufen, falls weitere Aktionen im DropIn nötig sind.
   * Diese Aktionen können zum Beispiel ein Redirect sein oder eine 3DS2-Überprüfung.
   */
  private onAdditionalDetailsNative(state: any): void {
    const me = this;

    me.MakeAdyenPaymentDetails(state.data)
      .then(me.HandleDropInPaymentResultNative)
      .catch((error) => {
        me.triggerErrorNative("Zahlung fehlgeschlagen", "CheckoutComponent.onAdditionalDetailsNative", "MakeAdyenPaymentDetails", error);
      });
  }

  // https://docs.adyen.com/payment-methods/google-pay/web-drop-in/
  private async prepareGooglePay(paymentMethodsConfiguration: any): Promise<void> {
    if (paymentMethodsConfiguration.paywithgoogle) {

      if (this.isIOS()) {
        // The GooglePay configuration has to be removed before the main adyen dropin is created. The split view uses this data too.
        this._adyenDropInOptions = this.removePaymentMethodFromDropInOptions(this._adyenDropInOptions, this.GOOGLE_PAY_TYPE);
      } else {
        paymentMethodsConfiguration.paywithgoogle.buttonColor = env.useDarkTheme ? "white" : "black";
        paymentMethodsConfiguration.paywithgoogle.buttonType = "checkout";
        paymentMethodsConfiguration.paywithgoogle.onAuthorized = function (data) {
          // Called after the shopper approves the payment on the Google Pay form. Contains the full response from Google Pay. Use this if you need additional data such as the shipping address or the shopper email.
        };

        try {
          await this.injectScript(env.checkout.adyen.google_script.src);
        } catch (error) {
          this._coreLogService.error("CheckoutComponent.prepareGooglePay", "injectScriptForGoogle", error);
        }
      }
    }
  }

  /** Schaltet ApplePay bei wenn möglich ein oder aus
   * @param checkout AdyenCheckout
   */
  private async verifyApplePayConfigurations(checkout: any): Promise<void> {
    const me = this;
    if (me.isApplePayAvailableInDropInOptions(me._adyenDropInOptions)) {
      try {
        let hasApplePaySupport = await me.isApplePaySupported(checkout);

        if (!hasApplePaySupport) {
          if (me.useSplitPaymentMethods) {
            me.adyenPaymentMethods = me.adyenPaymentMethods.filter(paymentMethod => paymentMethod.type !== me.APPLE_PAY_TYPE);
          } else {
            me.adyenPaymentIcons = me.adyenPaymentIcons.filter(svgName => !svgName.includes(me.APPLE_PAY_TYPE));
          }
        }
      } catch (applePaySupportError) {
        me._coreLogService.error("CheckoutComponent.verifyApplePayConfigurations", "isApplePaySupported", applePaySupportError);
      }
    }
  }

  private async initialShippingCartData() {
    const me = this;
    me.serviceId = me._webShopService.getServiceMode();
    me.currentLocation = me._webShopService.locationID;

    try {
      const location = await me._locationService.GetWebshopCheckoutLocationViewModelByID(me.currentLocation);

      if (!location) {
        throw new Error("Standort nicht gefunden oder leer.");
      }

      me.checkoutLocation = location;
    } catch (error) {
      const errorMessage = error.message || "Ein Fehler ist aufgetreten.";
      me._coreLogService.error("error", errorMessage);
    }
  }
  public ngOnChanges(changes: SimpleChanges) {
    // Respond when Angular (re)sets data-bound input properties. The method receives a SimpleChanges object of current and previous property values.
    // Called before ngOnInit() and whenever one or more data- bound input properties change.

    // ngOnChanges wird nur aufgerufen, wenn auch wirklich etwas an die @Input-Properties übergeben wird.
    // => Dann kann der Aufruf aber nicht über einen routerLink oder die direkte Eingabe der URL sein.
    // => Dann müssen wir uns nicht über die Überwachung der @Input-Properties kümmern,
    //    dazu wird automatisch ngOnChanges von angular 2 aufgerufen.
    // => Wenn die @Input-Property nicht gesetzt ist, dann sollte hier der Standardwert gesetzt werden.
    if (this._backRoute !== null) {
      this.backRoute = this._backRoute;
    } else {
      this.backRoute = this._defaultHomeRoute; // Standardwert auf Home
    }
    // => ngOnChanges darf nie asynchron ausgeführt werden, damit der Wert von inputBinding richtig gesetzt ist
    //    bevor ngOnInit ausgeführt wird!
    // Mit dem Setzen von inputBinding wird Komponente für die gesamte Lebenszeit signalisiert, dass diese
    // Komponente in eine andere Komponente eingefügt wurde.
  }

  public ngOnInit(): void {
    const me = this;
    // Initialize the directive/component after Angular first displays the data-bound properties and sets the directive/component"s input properties.
    // Called once, after the first ngOnChanges().
    // this.fakeInitialise();
    this.setLanguageBasedStrings();
    this._localeChangeSubscription =
      this._internationalisationService.localeChanged.subscribe(() => {
        this.setLanguageBasedStrings();
      });
    this.initialShippingCartData();

    me.subscribeAccountPaymentStreams();
    me.PushChanges();
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me.externIntentSupscription) {
      me.externIntentSupscription.unsubscribe();
    }
    if (me._localeChangeSubscription) {
      me._localeChangeSubscription.unsubscribe();
    }
    if (me._validationSubscrition) {
      me._validationSubscrition.unsubscribe();
    }
    me._destroy$.next();
    me._destroy$.complete();
  }

  public onUseWebvoucherChange(event: MatCheckboxChange) {
    const me = this;
    me.setUseWebvoucher(event.checked);
  }

  public setUseWebvoucher(use: boolean) {
    const me = this;
    me.useWebvoucherBalance = use; // todo useWebvoucherBalance status ändert nicht die Checkbox an die es gebunden ist
    if (use) {
      const webvoucher_total = me.webvoucherBalanceTotal;
      // Gutschein vom offenem Preis abziehen
      me.order.paymentAmount = Utils.moneyRound(
        Math.max(me.order.grossprice - webvoucher_total, 0)
      );
      // Abgezogener Preis mit Gutschein zahlen
      me.order.partialPaymentAmount = Utils.moneyRound(
        Math.max(me.order.grossprice - me.order.paymentAmount, 0)
      );
    } else {
      // Reset der Preise
      me.order.paymentAmount = Utils.moneyRound(me.order.grossprice);
      me.order.partialPaymentAmount = 0;
    }
    me.TryGetPaymentMethods(me.order).then(/* run it async */);
  }

  // === Visual
  // format price base on language
  public priceFormatter(price: number): string {
    const me = this;
    return me._webShopService.formatCurrency(price);
  }

  private setLanguageBasedStrings() {
    const me = this;
    me.webvoucherInputPlaceholder = me._coreLanguageService.value(
      "phPayment_RedeemWebvoucher"
    );
    me.commentPlaceholder = me._coreLanguageService.value(
      "phPayment_CommentToYourOrder"
    );
    me.setWebVoucherInfoHtml();
    me.setTermAcceptance();
  }

  private setWebVoucherInfoHtml() {
    const me = this;
    if (me.webvoucherCardNr) {
      const total_balance =
        me.webvoucherBalance + me.webvoucherBalanceBonus || 0;
      const webvoucherPriceformatted = this.priceFormatter(total_balance);
      let placeholder = null;
      if (me.show_hs_webvoucher) {
        placeholder = me.webvoucherDiscount
          ? "phPayment_Webvoucher_Info_Discount_BASE"
          : "phPayment_Webvoucher_Info_BASE";
      } else {
        placeholder = me.webvoucherDiscount
          ? "phPayment_Webvoucher_OnlyNrAndDiscount_BASE"
          : "phPayment_Webvoucher_OnlyNr_BASE";
      }
      me.webvoucherInfoText = _.escape(
        this._coreLanguageService.value(placeholder)
      )
        .replace(
          "{Nr}",
          `<span class="emphasized">Nr. ${me.webvoucherCardNr}</span>`
        )
        .replace(
          "{SimpleNr}",
          `<span class="emphasized">${me.webvoucherCardNr}</span>`
        )
        .replace(
          "{Amount}",
          `<span class="emphasized">${webvoucherPriceformatted}</span>`
        )
        .replace(
          "{Discount}",
          `<span class="emphasized">${me.webvoucherDiscount}%</span>`
        );
    }
  }

  public get impressumModelData() {
    const me = this;
    return me.checkoutLocation;
  }

  public openLocationImpressumDialog() {
    const me = this;
    me._bottomSheetHelperService.open(
      LocationImpressumDialogComponent,
      {
        data: {
          impressumHtml: me._domSanitizer.bypassSecurityTrustHtml(me.impressumModelData.impressumHtml),
        },
        panelClass: "mat-bottom-sheet-container--full-height",
      }
    );
  }

  private openPaymentErrorDialog(IsMultipleOrderError: boolean) {
    this._MatDialog.open(ErrorDialogComponent, {
      data: {
        title: IsMultipleOrderError ? "phErrorMessage_Title_MultipleOrder" : "phErrorMessage_Title",
        description: IsMultipleOrderError ? "phErrorMessage_Text_MultipleOrder" : "phErrorMessage_Text_ResetBasket",
      },
      panelClass: "error-dialog-styles",
    });
  }

  public selectPaymentMethod(
    event: MatCheckboxChange,
    pm: CheckboxPaymentMethod
  ) {
    const me = this;
    if (pm === CheckboxPaymentMethod.Accounting && me.handleAccountPaymentRowClick(event)) { return; }
    me.selectedPaymentMethod = event.checked
      ? pm
      : CheckboxPaymentMethod.None;
    me.PushChanges();
  }

  public selectSinglePaymentMethod(
    event: MatCheckboxChange,
    paymentMethod: string
  ) {
    const me = this;
    if (paymentMethod === me.stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Accounting)
      && me.handleAccountPaymentRowClick(event)) { return; }
    me.selectedSinglePaymentMethod = event.checked ? paymentMethod : "";
    me.trackPaymentInfo(paymentMethod);
    me.PushChanges();
  }

  private trackPaymentInfo(paymentMethod: string): void {
    if (!this.order || !this.order.items || !this.order.items.length) return;

    this._trackingManager.trackPaymentInfo(
      paymentMethod
    );
  }

  public stringifyCheckboxPaymentMethod(
    paymentMethod: CheckboxPaymentMethod
  ): string {
    return CheckboxPaymentMethod[paymentMethod];
  }

  /** hält global die Order Refferenc als ID und Token fest und speichert es im Cache */
  private async setOrderID(order_id: string, order_token: string) {
    this._order_id = order_id;
    this._order_token = order_token;
    this.saveLastOrderInfo();
  }


  public async onConfirmOrderData(): Promise<void> {
    const me = this;
    if (me.hasAcceptedAGB) {
      me.newsletterCheckbox.submitNewsletterOptIn();
      if (me.order) {
        if (me._webShopService.isTimeRequired) {
          const shouldProceed = await me.validateAndUpdateServiceTime();
          if (!shouldProceed) {
            return;
          }
        }

        if (me.useWebvoucherBalance && me.order.paymentAmount === 0) {
          me.Webvoucher();
        } else {
          if (me.useSplitPaymentMethods) {
            await me.pay(me.selectedSinglePaymentMethod);
          } else {
            await me.executePayment(me.selectedPaymentMethod);
          }
        }
      } else {
        me._snackBarService.ShowErrorMessageFailed(125);
        throw Error("no Order found");
      }
    } else {
      // TODO Show User that AGB has not been accepted
    }
  }

  /**
   * Validates the selected service time and updates the order accordingly.
   * For events, navigates user to basket; otherwise proceeds to payment.
   * @returns true if payment should proceed, false if navigation/cancellation occurred
   */
  private async validateAndUpdateServiceTime(): Promise<boolean> {
    const me = this;
    const navigationOptions: INavigationOptions = {
      navigateBeforeDialog: false,
      navigateOnClose: true
    }

    const result = await me._orderTimeValidationService.validateServiceTime(navigationOptions);
    me.PushChanges();
    // No selected time > navigate to time selector
    if (result.status === TimeSelectionStatus.None) {
      await me._router.navigate([NavigationRoute.OrderTimeSelector]);
      return false;
    }

    // No Valid Time
    if (result.status !== TimeSelectionStatus.Valid &&
      result.status !== TimeSelectionStatus.TimeUpdated) {
      return false;
    }

    // update service time in order
    if (me._webShopService.serviceOrderTime) {
      me.order.wantedHandoverDate = Utils.GetYMDFromMoment(moment(me._webShopService.serviceOrderTime)) || 0;
      me.order.wantedHandoverTime = Utils.GetHMSFromMoment(moment(me._webShopService.serviceOrderTime)) || 0;

      // Apply ASAP flag if selected
      if (me._webShopService.orderASAP) {
        me.order.wantedHandoverDate = me.order.wantedHandoverDate === 0 ? -1 : -me.order.wantedHandoverDate;
      }

      me.PushChanges();
    }

    await Promise.resolve();

    if (!me.isAllowedToPay) {
      return false;
    }

    // Event is active & time was updated > navigate to basket
    if (me._webShopService.currentEventID && result.status === TimeSelectionStatus.TimeUpdated) {
      me.navigateToBasket.emit();
      return false;
    }

    return true;// load payment
  }

  /** Diese funktion ist zwischenzeitlich als unterstützung,
   *  um den UserBasket abzugleichen, wenn die rabatte nicht übereinstimmen,
   *  da sich mitten beim einkauf der Rabatt gewährt wurde */
  private async ResyncInHouseUserBasketWithServer(): Promise<boolean> {
    const me = this;
    // ! achtung dass muss mit dem richtigen InHouseRabatt umgesetzt werden
    // Momentan können InHouse Bestellungen mit mandatory_payment Rabatt haben
    // dafür muss der Rabatt mit dem Server abgeglichen werden
    if (me.in_house) {
      // Momentan ist Rabatt nur im Warenkorb, es muss einmal vor der Zahlung mit dem Server abgeglichen werden
      try {
        // bei einem Tisch mit zahlungszwang, kann es Rabatt geben
        // darum sollte der UserBasket neu abgeglichen werden
        if (me._inHouseOrderService.TableData.mandatory_Payment) {
          await me._inHouseOrderService.AbortPaymentSelect(); // pause payment select (to change user_basket)
          const resfresh_success = await me._webShopService.refreshYASUserBasket();
          if (!resfresh_success)
            throw new Error("refreshYASUserBasket faild");
        }
      } catch (error) {
        me._coreLogService.error("CheckoutComponent.ResyncInHouseUserBasketWithServer", "catch", error);
        me.HandlePaymentError(""); // show error message
        await me._inHouseOrderService.StartPaymentSelect(); // restart payment select
        return false;
      }
      await me._inHouseOrderService.StartPaymentSelect(); // restart payment select
    } // else no inhouse, continue with payment

    return true;
  }

  /** Startet das Payment einer bestimmten zahlungsmethode */
  private async pay(paymentMethod: string): Promise<void> {
    const me = this;

    if (!await me.ResyncInHouseUserBasketWithServer()) {
      return; // break here
    }

    try {
      switch (paymentMethod) {
        case me.stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.PayAtWaiter): {
          await me.PayAtWaiter();
          break;
        }
        case me.stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Cash): {
          await me.Cash();
          break;
        }
        case me.stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Cashless): {
          await me.Cashless();
          break;
        }
        case me.stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Accounting): {
          await me.payWithAccountingIfSelectable();
          break;
        }
        case me.stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.PayPal): {
          await me.PayPal();
          break;
        }
        default: {
          if (me.isBrowser()) {
            me.mountAdyenDropIn(me._adyenCheckout, paymentMethod);
          } else {
            if (me.isAndroid() && me.isGooglePay(paymentMethod)) {
              await me.injectScript(env.checkout.adyen.google_script.src);
            }

            me._filteredAdyenDropInOptions = me.filterDropInOptions(me._adyenDropInOptions, paymentMethod);
          }
          me.Adyen();
          break;
        }
      }
    } catch (paymentError) {
      me._coreLogService.error("CheckoutComponent.pay", paymentError);
    }
  }

  private filterDropInOptions(adyenDropInOptions: any, paymentMethodType: string): any {
    const equality = (x, y) => { return x === y };
    return this.editDropInOptions(adyenDropInOptions, paymentMethodType, equality)
  }

  /** Bindet den gewünschten type an die DOM
   * @param checkout AdyenCheckout
   * @param type Art der Darstellung "dropin" oder einzelne componenten des Dropins
   */
  private mountAdyenDropIn(checkout: any, type: string): void {
    const me = this;

    if (me._adyenWebDropIn) {
      me._adyenWebDropIn.unmount("#dropin-container");
    }

    me._adyenWebDropIn = checkout.create(type);
    me._adyenWebDropIn.mount("#dropin-container");
  }

  private async executePayment(paymentMethod: CheckboxPaymentMethod): Promise<void> {
    const me = this;

    if (!await me.ResyncInHouseUserBasketWithServer()) {
      return; // break here
    }

    try {
      switch (paymentMethod) {
        case CheckboxPaymentMethod.Cash: {
          await me.Cash();
          break;
        }
        case CheckboxPaymentMethod.Cashless: {
          await me.Cashless();
          break;
        }
        case CheckboxPaymentMethod.Accounting: {
          await me.payWithAccountingIfSelectable();
          break;
        }
        case CheckboxPaymentMethod.PayPal: {
          await me.PayPal();
          break;
        }
        case CheckboxPaymentMethod.Adyen: {
          me.Adyen();
          break;
        }
        case CheckboxPaymentMethod.Wallee: {
          me.Wallee();
          break;
        }
      }
    } catch (paymentError) {
      me._coreLogService.error("CheckoutComponent.executePayment", paymentError);
    }
  }

  private getEndServiceTime() {
    const me = this;
    const serviceOpenTime = me._webShopService.getOpenTimeService();
    const serviceOrderDayTime = moment(me._webShopService.serviceOrderTime);
    const serviceStartTime = moment(serviceOrderDayTime)
      .hours((serviceOpenTime[0].start_hms / 10000) % 100)
      .minutes((serviceOpenTime[0].start_hms / 100) % 100)
      .seconds(serviceOpenTime[0].start_hms % 100);
    const serviceEndTime = moment(serviceOrderDayTime)
      .hours(
        (serviceOpenTime[serviceOpenTime.length - 1].end_hms / 10000) % 100
      )
      .minutes(
        (serviceOpenTime[serviceOpenTime.length - 1].end_hms / 100) % 100
      )
      .seconds(serviceOpenTime[serviceOpenTime.length - 1].end_hms % 100);

    if (serviceEndTime.isBefore(serviceStartTime)) {
      serviceEndTime.add(1, "days");
    }
    return serviceEndTime;
  }

  //public calcSums(): Promise<void> {
  //  const me = this;
  //  // todo es sollte sich immer aus der bestellung berechnen und nicht aus dem Warenkorb
  //  if (me.order.ordertype === orderTypes.inHouse){
  //    me.sum_total = me.order.grossprice;
  //    me.sum_discount =  me.order.discountTotal;
  //    me.sum_deposit =  me.order.deposit;
  //    me.sum_delivery_fee = me.order.deliveryCost;
  //    me.sum_tip = me.order.tip;
  //    me.sum_base = me.sum_total - (me.sum_discount + me.sum_deposit + me.sum_delivery_fee + me.sum_tip);
  //    me.vatStats = me.order.vatStats; await me._webShopService.getVatStatsFromInHouseOrder();
  //  } else {
  //    me.sum_base = me._webShopService.getBasketSum(); // ! Brutto nicht Netto
  //    me.sum_discount = me._webShopService.getBasketSumDiscount();
  //    me.sum_deposit = me._webShopService.getBasketSumDeposit();
  //    me.sum_delivery_fee = me._webShopService.finalDeliveryFee;
  //    me.sum_tip = me._webShopService.trinkgeldValue;
  //    me.sum_total = me.sum_base - me.sum_discount + me.sum_deposit + me.sum_delivery_fee + me.sum_tip;
  //    // Vat Sums
  //    me.vatStats = me._webShopService.getBasketVatStats();
  //    me.vatStats.sort((a, b) => b.percent - a.percent);
  //  }
  //  me.PushChanges();
  //}

  private setTermAcceptance(): void {
    const me = this;
    // Get Data From Resolver Data
    const resolverData = me._activatedRoute.snapshot.data["settingsViewModel"];
    if (resolverData) {
      me.settingsViewModel = resolverData["settingsViewModel"];
      me.AGB_innerhtml = me.settingsViewModel.register_term_text;
      me.AGB_innerhtml = me._domSanitizer.bypassSecurityTrustHtml(
        me.AGB_innerhtml
      );
      me.PushChanges();
    }
  }

  public openTermModel(termId: number): void {
    const me = this;
    me._termService.openTermModel(termId);
  }

  public onShowTermsClick(event: any) {
    const target: HTMLElement = event.target;
    if (target.id) {
      const eleIdArray: string[] = target.id.split("-");
      if (eleIdArray.length === 2) {
        const termid: number = +eleIdArray[eleIdArray.length - 1];
        if (termid !== null) {
          this.openTermModel(termid);
        }
      }
    }
    event.stopPropagation();
  }

  private addStylingToInputFields(pmconfig: any): any {
    const me = this;
    const rootComputedStyle = window.getComputedStyle(document.documentElement);

    const styleObject = {
      base: {
        color: rootComputedStyle.getPropertyValue("--adyen-input-base-color"),
      },
      error: {
        color: rootComputedStyle.getPropertyValue("--adyen-input-error-color"),
      },
      placeholder: {
        color: rootComputedStyle.getPropertyValue(
          "--adyen-input-placeholder-color"
        ),
        background: 'unset',
      },
      validated: {
        color: rootComputedStyle.getPropertyValue(
          "--adyen-input-validated-color"
        ),
      },
    };

    if (pmconfig) {
      if (pmconfig["card"]) {
        pmconfig["card"]["styles"] = styleObject;
      }
    }
  }

  public get isAllowedToPay(): boolean {
    const me = this;
    if (me.hasAcceptedAGB) {
      if (me.order) {
        return (
          (me.useSplitPaymentMethods
            ? me.selectedSinglePaymentMethod !== ""
            : me.selectedPaymentMethod !== CheckboxPaymentMethod.None) ||
          me.order.paymentAmount === 0
        );
      }
    }
    return false;
  }

  private openUnsupportedCardTypeDialog() {
    const me = this;
    me._bottomSheetHelperService.open(
      WarningdialogComponent,
      {
        data: {
          title: "phPayment_UnsupportedCardType_Title",
          content: "phPayment_UnsupportedCardType_Content",
          btnLabel: "phPayment_UnsupportedCardType_Button",
        },
        panelClass: "mat-bottom-sheet-container--full-height",
      }
    );
  }

  private openVoucherCannotBeUsed() {
    const me = this;
    me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
      data: {
        title: "phInHouse_Discount_Title",
        description: "phInHouse_Voucher_Info",
        buttonTextAccept: "phGlobal_Continue",
        icon: "hypersoft-coupon.svg",
      },
      panelClass: "mat-bottom-sheet-container-medium",
    });
  }

  private isIOS(): boolean {
    return this.checkPlatform(ClientType.ios);
  }

  private isAndroid(): boolean {
    return this.checkPlatform(ClientType.android);
  }

  private isBrowser(): boolean {
    return this.checkPlatform(ClientType.browser);
  }

  private checkPlatform(type: ClientType) {
    return this.getClientType() === type;
  }

  private getClientType(): ClientType {
    return this._coreCOMService.environment.client.type;
  }
}
